// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import axios from "axios";
// import { useAuth } from "@/context/AuthContext";
// import { motion, AnimatePresence } from "framer-motion";
// import { toast } from "sonner";
// import {
//   Users,
//   TrendingUp,
//   TrendingDown,
//   Plus,
//   X,
//   Search,
//   ChevronRight,
//   ArrowLeft,
//   Wallet,
//   FileText,
//   CreditCard,
//   Banknote,
//   AlertCircle,
//   Building2,
//   Phone,
//   Hash,
//   Trash2,
//   Edit2,
//   Check,
//   ArrowUpRight,
//   ArrowDownLeft,
//   Clock,
//   IndianRupee,
//   RefreshCw,
//   Loader2,
//   CheckCircle2,
//   AlertTriangle,
// } from "lucide-react";

// const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// // ── Helpers ───────────────────────────────────────────────────
// const rupee = (n) => `₹${(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
// const fmt = (iso) =>
//   iso
//     ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
//     : "—";

// const ENTRY_META = {
//   // Debtor entries
//   sale_invoice: { label: "Sale Invoice", icon: FileText, color: "text-rose-400", bg: "bg-rose-500/15", dir: "dr" },
//   payment_received: { label: "Payment Received", icon: Banknote, color: "text-emerald-400", bg: "bg-emerald-500/15", dir: "cr" },
//   debit_note: { label: "Debit Note", icon: TrendingUp, color: "text-orange-400", bg: "bg-orange-500/15", dir: "dr" },
//   // Creditor entries
//   purchase_invoice: { label: "Purchase Invoice", icon: CreditCard, color: "text-rose-400", bg: "bg-rose-500/15", dir: "dr" },
//   payment_made: { label: "Payment Made", icon: Banknote, color: "text-emerald-400", bg: "bg-emerald-500/15", dir: "cr" },
//   credit_note: { label: "Credit Note", icon: TrendingDown, color: "text-blue-400", bg: "bg-blue-500/15", dir: "cr" },
// };

// const DEBTOR_ENTRY_TYPES = [
//   { value: "sale_invoice", label: "Sale Invoice (Dr)" },
//   { value: "payment_received", label: "Payment Received (Cr)" },
//   { value: "debit_note", label: "Debit Note (Dr)" },
//   { value: "credit_note", label: "Credit Note (Cr)" },
// ];

// const CREDITOR_ENTRY_TYPES = [
//   { value: "purchase_invoice", label: "Purchase Invoice (Dr)" },
//   { value: "payment_made", label: "Payment Made (Cr)" },
//   { value: "debit_note", label: "Debit Note (Dr)" },
//   { value: "credit_note", label: "Credit Note (Cr)" },
// ];

// // ── Stat Card ─────────────────────────────────────────────────
// const StatCard = ({ label, value, sub, icon: Icon, color, delay }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 12 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ delay }}
//     className="bg-[#1c1c2e] rounded-2xl p-5 border border-white/8"
//   >
//     <div className="flex items-start justify-between mb-3">
//       <p className="text-[10px] text-stone-500 uppercase tracking-widest font-bold">{label}</p>
//       <div className={`p-1.5 rounded-xl ${color.replace("text-", "bg-").replace("400", "500/15")}`}>
//         <Icon size={14} className={color} />
//       </div>
//     </div>
//     <p className={`font-mono font-black text-2xl ${color}`}>{value}</p>
//     {sub && <p className="text-[10px] text-stone-500 mt-1">{sub}</p>}
//   </motion.div>
// );

// // ── Party Card ─────────────────────────────────────────────────
// const PartyCard = ({ party, index, onClick }) => {
//   const isDebtor = party.party_type === "debtor";
//   const bal = party.balance || 0;
//   const isOverdue = bal > 0 && party.has_old_entries;

//   return (
//     <motion.div
//       initial={{ opacity: 0, x: -8 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ delay: index * 0.03 }}
//       onClick={onClick}
//       className="group flex items-center justify-between p-4 bg-white rounded-2xl border border-stone-100 hover:border-stone-300 hover:shadow-md cursor-pointer transition-all active:scale-[0.99]"
//     >
//       <div className="flex items-center gap-3">
//         <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-black text-sm ${isDebtor ? "bg-rose-100 text-rose-600" : "bg-blue-100 text-blue-600"}`}>
//           {party.name[0].toUpperCase()}
//         </div>
//         <div>
//           <p className="font-bold text-sm text-stone-800 flex items-center gap-2">
//             {party.name}
//             {isOverdue && (
//               <span className="text-[9px] font-black bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full border border-amber-200">
//                 OVERDUE
//               </span>
//             )}
//           </p>
//           <div className="flex items-center gap-2 mt-0.5">
//             {party.phone && (
//               <p className="text-[10px] text-stone-400 flex items-center gap-1">
//                 <Phone size={9} />{party.phone}
//               </p>
//             )}
//             <p className="text-[10px] text-stone-400">
//               {party.entry_count || 0} entries
//             </p>
//           </div>
//         </div>
//       </div>
//       <div className="flex items-center gap-3">
//         <div className="text-right">
//           <p className={`font-mono font-black text-base ${bal > 0 ? (isDebtor ? "text-rose-600" : "text-blue-600") : "text-emerald-600"}`}>
//             {rupee(Math.abs(bal))}
//           </p>
//           <p className="text-[9px] text-stone-400 font-semibold uppercase">
//             {bal === 0 ? "Settled" : bal > 0 ? (isDebtor ? "You'll receive" : "You owe") : "Advance/Credit"}
//           </p>
//         </div>
//         <ChevronRight size={14} className="text-stone-300 group-hover:text-stone-500 transition-colors shrink-0" />
//       </div>
//     </motion.div>
//   );
// };

// // ── Add Party Modal ────────────────────────────────────────────
// const AddPartyModal = ({ partyType, onClose, onSaved, token }) => {
//   const [form, setForm] = useState({ name: "", phone: "", address: "", gstin: "", opening_balance: 0, notes: "" });
//   const [saving, setSaving] = useState(false);

//   const handleSave = async () => {
//     if (!form.name.trim()) { toast.error("Name is required"); return; }
//     setSaving(true);
//     try {
//       const res = await axios.post(
//         `${API_URL}/sundry/parties`,
//         { ...form, party_type: partyType },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       toast.success(`${partyType === "debtor" ? "Debtor" : "Creditor"} added!`);
//       onSaved(res.data);
//     } catch (err) {
//       toast.error(err?.response?.data?.detail || "Failed to save");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const isDebtor = partyType === "debtor";

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//       className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
//       onClick={onClose}
//     >
//       <motion.div
//         initial={{ scale: 0.94, y: 16 }}
//         animate={{ scale: 1, y: 0 }}
//         exit={{ scale: 0.94, y: 16 }}
//         transition={{ type: "spring", stiffness: 340, damping: 30 }}
//         className="bg-[#1c1c2e] border border-white/10 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
//           <div className="flex items-center gap-3">
//             <div className={`p-2 rounded-xl border ${isDebtor ? "bg-rose-500/15 border-rose-500/20" : "bg-blue-500/15 border-blue-500/20"}`}>
//               <Users size={16} className={isDebtor ? "text-rose-400" : "text-blue-400"} />
//             </div>
//             <div>
//               <p className="text-[10px] text-stone-500 uppercase tracking-widest">New Party</p>
//               <p className="text-white font-black text-sm">{isDebtor ? "Add Debtor" : "Add Creditor"}</p>
//             </div>
//           </div>
//           <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors">
//             <X size={16} />
//           </button>
//         </div>

//         <div className="px-6 py-5 space-y-3">
//           {[
//             { label: "Party Name *", key: "name", placeholder: isDebtor ? "e.g. Ramesh Builders" : "e.g. Asian Tiles Pvt Ltd" },
//             { label: "Phone", key: "phone", placeholder: "9876543210", type: "tel" },
//             { label: "GSTIN", key: "gstin", placeholder: "24XXXXX..." },
//             { label: "Address", key: "address", placeholder: "City, State" },
//           ].map(({ label, key, placeholder, type }) => (
//             <div key={key}>
//               <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">{label}</label>
//               <input
//                 type={type || "text"}
//                 value={form[key]}
//                 onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
//                 placeholder={placeholder}
//                 className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-amber-500/60 placeholder-stone-600 transition-colors"
//               />
//             </div>
//           ))}
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">
//               Opening Balance (₹) <span className="text-stone-600 font-normal normal-case">— amount already owed</span>
//             </label>
//             <input
//               type="number"
//               min={0}
//               value={form.opening_balance}
//               onChange={(e) => setForm((f) => ({ ...f, opening_balance: parseFloat(e.target.value) || 0 }))}
//               className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white font-mono outline-none focus:border-amber-500/60 transition-colors"
//             />
//           </div>
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">Notes</label>
//             <textarea
//               value={form.notes}
//               onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
//               rows={2}
//               className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-amber-500/60 placeholder-stone-600 resize-none transition-colors"
//               placeholder="Optional notes..."
//             />
//           </div>
//         </div>

//         <div className="px-6 pb-5 flex gap-3">
//           <button onClick={onClose} className="flex-1 py-3 rounded-2xl bg-stone-700/50 hover:bg-stone-700 text-stone-300 text-sm font-bold transition-colors border border-white/10">
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             className={`flex-1 py-3 rounded-2xl text-sm font-bold flex items-center justify-center gap-2 transition-all disabled:opacity-50 ${isDebtor ? "bg-rose-500 hover:bg-rose-400 text-white" : "bg-blue-500 hover:bg-blue-400 text-white"}`}
//           >
//             {saving ? <Loader2 size={15} className="animate-spin" /> : <Plus size={15} />}
//             Add {isDebtor ? "Debtor" : "Creditor"}
//           </button>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// };

// // ── Add Entry Modal ────────────────────────────────────────────
// const AddEntryModal = ({ party, onClose, onSaved, token }) => {
//   const isDebtor = party.party_type === "debtor";
//   const types = isDebtor ? DEBTOR_ENTRY_TYPES : CREDITOR_ENTRY_TYPES;
//   const defaultType = isDebtor ? "sale_invoice" : "purchase_invoice";

//   const [form, setForm] = useState({
//     entry_type: defaultType,
//     amount: "",
//     date: new Date().toISOString().split("T")[0],
//     description: "",
//     invoice_ref: "",
//   });
//   const [saving, setSaving] = useState(false);

//   const handleSave = async () => {
//     if (!form.amount || parseFloat(form.amount) <= 0) { toast.error("Enter a valid amount"); return; }
//     setSaving(true);
//     try {
//       const res = await axios.post(
//         `${API_URL}/sundry/entries`,
//         { ...form, party_id: party.id, amount: parseFloat(form.amount) },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       toast.success("Entry added!");
//       onSaved(res.data);
//     } catch (err) {
//       toast.error(err?.response?.data?.detail || "Failed to add entry");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const meta = ENTRY_META[form.entry_type];

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//       className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
//       onClick={onClose}
//     >
//       <motion.div
//         initial={{ scale: 0.94, y: 16 }}
//         animate={{ scale: 1, y: 0 }}
//         exit={{ scale: 0.94, y: 16 }}
//         transition={{ type: "spring", stiffness: 340, damping: 30 }}
//         className="bg-[#1c1c2e] border border-white/10 rounded-3xl shadow-2xl w-full max-w-md overflow-hidden"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
//           <div>
//             <p className="text-[10px] text-stone-500 uppercase tracking-widest">New Transaction</p>
//             <p className="text-white font-black text-sm">{party.name}</p>
//           </div>
//           <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors">
//             <X size={16} />
//           </button>
//         </div>

//         <div className="px-6 py-5 space-y-3">
//           {/* Entry type selector */}
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1.5">Transaction Type</label>
//             <div className="grid grid-cols-2 gap-1.5">
//               {types.map((t) => {
//                 const m = ENTRY_META[t.value];
//                 return (
//                   <button
//                     key={t.value}
//                     onClick={() => setForm((f) => ({ ...f, entry_type: t.value }))}
//                     className={`flex items-center gap-2 px-3 py-2.5 rounded-xl border text-xs font-bold transition-all text-left ${
//                       form.entry_type === t.value
//                         ? `${m.bg} ${m.color} border-current/30`
//                         : "bg-white/5 text-stone-400 border-white/10 hover:border-white/20"
//                     }`}
//                   >
//                     <m.icon size={12} className="shrink-0" />
//                     <span className="truncate">{t.label}</span>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Amount */}
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">Amount (₹) *</label>
//             <div className="relative">
//               <IndianRupee size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
//               <input
//                 type="number"
//                 min={0}
//                 value={form.amount}
//                 onChange={(e) => setForm((f) => ({ ...f, amount: e.target.value }))}
//                 placeholder="0.00"
//                 className="w-full bg-white/8 border border-white/15 rounded-xl pl-8 pr-3 py-2.5 text-sm text-white font-mono outline-none focus:border-amber-500/60 placeholder-stone-600 transition-colors"
//               />
//             </div>
//           </div>

//           {/* Date */}
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">Date *</label>
//             <input
//               type="date"
//               value={form.date}
//               onChange={(e) => setForm((f) => ({ ...f, date: e.target.value }))}
//               className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-amber-500/60 transition-colors"
//             />
//           </div>

//           {/* Invoice Ref */}
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">
//               Invoice / Bill No. <span className="text-stone-600 font-normal">(optional)</span>
//             </label>
//             <input
//               type="text"
//               value={form.invoice_ref}
//               onChange={(e) => setForm((f) => ({ ...f, invoice_ref: e.target.value }))}
//               placeholder="e.g. INV-2024-001"
//               className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-amber-500/60 placeholder-stone-600 transition-colors"
//             />
//           </div>

//           {/* Description */}
//           <div>
//             <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">Description</label>
//             <input
//               type="text"
//               value={form.description}
//               onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
//               placeholder="Brief note about this transaction..."
//               className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-amber-500/60 placeholder-stone-600 transition-colors"
//             />
//           </div>
//         </div>

//         <div className="px-6 pb-5 flex gap-3">
//           <button onClick={onClose} className="flex-1 py-3 rounded-2xl bg-stone-700/50 hover:bg-stone-700 text-stone-300 text-sm font-bold transition-colors border border-white/10">
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             className="flex-1 py-3 rounded-2xl bg-amber-500 hover:bg-amber-400 text-stone-900 text-sm font-bold flex items-center justify-center gap-2 transition-all disabled:opacity-50"
//           >
//             {saving ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />}
//             Add Entry
//           </button>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// };

// // ── Ledger View ────────────────────────────────────────────────
// const LedgerView = ({ party, token, onBack, onPartyUpdated }) => {
//   const [ledger, setLedger] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showAddEntry, setShowAddEntry] = useState(false);
//   const [deletingId, setDeletingId] = useState(null);
//   const isDebtor = party.party_type === "debtor";
//   const { user } = useAuth();
//   const isAdmin = user?.role === "admin";

//   const fetchLedger = useCallback(async () => {
//     try {
//       const res = await axios.get(`${API_URL}/sundry/parties/${party.id}/ledger`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setLedger(res.data);
//     } catch {
//       toast.error("Failed to load ledger");
//     } finally {
//       setLoading(false);
//     }
//   }, [party.id, token]);

//   useEffect(() => { fetchLedger(); }, [fetchLedger]);

//   const handleDeleteEntry = async (entryId) => {
//     setDeletingId(entryId);
//     try {
//       await axios.delete(`${API_URL}/sundry/entries/${entryId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success("Entry deleted");
//       fetchLedger();
//     } catch (err) {
//       toast.error(err?.response?.data?.detail || "Failed to delete");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   if (loading)
//     return (
//       <div className="flex items-center justify-center h-64">
//         <Loader2 size={28} className="animate-spin text-amber-400" />
//       </div>
//     );

//   const { entries = [], closing_balance = 0, opening_balance = 0 } = ledger || {};
//   const isSettled = Math.abs(closing_balance) < 0.01;

//   return (
//     <div>
//       {/* Party Header */}
//       <div className="bg-[#1c1c2e] rounded-2xl p-5 mb-5 border border-white/8">
//         <div className="flex items-start justify-between">
//           <div className="flex items-center gap-3">
//             <button onClick={onBack} className="p-2 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors">
//               <ArrowLeft size={16} />
//             </button>
//             <div className={`w-11 h-11 rounded-xl flex items-center justify-center font-black text-lg ${isDebtor ? "bg-rose-500/20 text-rose-300" : "bg-blue-500/20 text-blue-300"}`}>
//               {party.name[0].toUpperCase()}
//             </div>
//             <div>
//               <p className="text-white font-black text-base">{party.name}</p>
//               <div className="flex items-center gap-2 mt-0.5">
//                 <span className={`text-[9px] font-black uppercase px-2 py-0.5 rounded-full ${isDebtor ? "bg-rose-500/15 text-rose-400 border border-rose-500/20" : "bg-blue-500/15 text-blue-400 border border-blue-500/20"}`}>
//                   {isDebtor ? "Debtor" : "Creditor"}
//                 </span>
//                 {party.phone && <span className="text-[10px] text-stone-500">{party.phone}</span>}
//                 {party.gstin && <span className="text-[10px] text-stone-500 font-mono">{party.gstin}</span>}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={() => setShowAddEntry(true)}
//             className="flex items-center gap-1.5 bg-amber-500 hover:bg-amber-400 text-stone-900 text-xs font-black px-4 py-2.5 rounded-xl transition-colors"
//           >
//             <Plus size={13} />
//             Add Entry
//           </button>
//         </div>

//         {/* Balance summary */}
//         <div className="grid grid-cols-3 gap-3 mt-4 pt-4 border-t border-white/10">
//           <div>
//             <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">Opening</p>
//             <p className="font-mono font-bold text-sm text-stone-300">{rupee(opening_balance)}</p>
//           </div>
//           <div>
//             <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">Transactions</p>
//             <p className="font-mono font-bold text-sm text-stone-300">{entries.length} entries</p>
//           </div>
//           <div>
//             <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">
//               {isSettled ? "Status" : (isDebtor ? "To Receive" : "To Pay")}
//             </p>
//             <p className={`font-mono font-black text-lg ${isSettled ? "text-emerald-400" : isDebtor ? "text-rose-400" : "text-blue-400"}`}>
//               {isSettled ? "✓ Settled" : rupee(Math.abs(closing_balance))}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Ledger entries */}
//       {entries.length === 0 ? (
//         <div className="bg-white rounded-2xl border border-stone-100 flex flex-col items-center justify-center py-16">
//           <FileText size={36} className="text-stone-200 mb-3" />
//           <p className="text-stone-400 font-semibold text-sm">No transactions yet</p>
//           <p className="text-stone-300 text-xs mt-1">Click "Add Entry" to record a transaction</p>
//         </div>
//       ) : (
//         <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
//           {/* Table header */}
//           <div className="grid grid-cols-12 gap-2 px-4 py-3 bg-[#1c1c2e] text-[9px] text-stone-400 font-bold uppercase tracking-widest">
//             <div className="col-span-2">Date</div>
//             <div className="col-span-3">Type</div>
//             <div className="col-span-3">Description</div>
//             <div className="col-span-2 text-right">Amount</div>
//             <div className="col-span-1 text-right">Balance</div>
//             <div className="col-span-1"></div>
//           </div>

//           <AnimatePresence>
//             {entries.map((entry, idx) => {
//               const meta = ENTRY_META[entry.entry_type] || {};
//               const isCr = ["payment_received", "payment_made", "credit_note"].includes(entry.entry_type);
//               return (
//                 <motion.div
//                   key={entry.id}
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: idx * 0.02 }}
//                   className="grid grid-cols-12 gap-2 px-4 py-3 border-b border-stone-50 hover:bg-stone-50/70 transition-colors group items-center"
//                 >
//                   <div className="col-span-2 text-xs text-stone-500 font-mono">{fmt(entry.date)}</div>
//                   <div className="col-span-3">
//                     <span className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full ${meta.bg || "bg-stone-100"} ${meta.color || "text-stone-500"}`}>
//                       {isCr ? <ArrowDownLeft size={9} /> : <ArrowUpRight size={9} />}
//                       {meta.label || entry.entry_type}
//                     </span>
//                     {entry.invoice_ref && (
//                       <p className="text-[9px] text-stone-400 mt-0.5 font-mono">{entry.invoice_ref}</p>
//                     )}
//                   </div>
//                   <div className="col-span-3 text-xs text-stone-500 truncate" title={entry.description}>
//                     {entry.description || "—"}
//                   </div>
//                   <div className="col-span-2 text-right">
//                     <span className={`font-mono font-bold text-sm ${isCr ? "text-emerald-600" : "text-rose-600"}`}>
//                       {isCr ? "-" : "+"}{rupee(entry.amount)}
//                     </span>
//                   </div>
//                   <div className="col-span-1 text-right">
//                     <span className={`font-mono text-xs font-semibold ${entry.running_balance > 0 ? "text-stone-600" : "text-emerald-600"}`}>
//                       {rupee(Math.abs(entry.running_balance))}
//                     </span>
//                   </div>
//                   <div className="col-span-1 flex justify-end">
//                     {isAdmin && (
//                       <button
//                         onClick={() => handleDeleteEntry(entry.id)}
//                         disabled={deletingId === entry.id}
//                         className="opacity-0 group-hover:opacity-100 p-1.5 hover:bg-rose-50 text-rose-400 rounded-lg transition-all"
//                       >
//                         {deletingId === entry.id
//                           ? <Loader2 size={11} className="animate-spin" />
//                           : <Trash2 size={11} />
//                         }
//                       </button>
//                     )}
//                   </div>
//                 </motion.div>
//               );
//             })}
//           </AnimatePresence>

//           {/* Closing balance row */}
//           <div className="grid grid-cols-12 gap-2 px-4 py-3 bg-stone-50 border-t-2 border-stone-200 items-center">
//             <div className="col-span-8 text-xs font-black text-stone-700 uppercase tracking-wide">
//               Closing Balance
//             </div>
//             <div className="col-span-2 text-right"></div>
//             <div className="col-span-1 text-right">
//               <span className={`font-mono font-black text-base ${isSettled ? "text-emerald-600" : isDebtor ? "text-rose-600" : "text-blue-600"}`}>
//                 {rupee(Math.abs(closing_balance))}
//               </span>
//             </div>
//             <div className="col-span-1"></div>
//           </div>
//         </div>
//       )}

//       <AnimatePresence>
//         {showAddEntry && (
//           <AddEntryModal
//             party={party}
//             token={token}
//             onClose={() => setShowAddEntry(false)}
//             onSaved={() => { setShowAddEntry(false); fetchLedger(); }}
//           />
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// // ═══════════════════════════════════════════════════════════════
// //  MAIN PAGE
// // ═══════════════════════════════════════════════════════════════
// const SundryLedger = () => {
//   const { token, user } = useAuth();
//   const [stats, setStats] = useState(null);
//   const [parties, setParties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState("debtor"); // "debtor" | "creditor"
//   const [search, setSearch] = useState("");
//   const [selectedParty, setSelectedParty] = useState(null);
//   const [showAddParty, setShowAddParty] = useState(false);

//   const canAccess = ["admin", "manager", "billing"].includes(user?.role);

//   const fetchAll = useCallback(async () => {
//     setLoading(true);
//     try {
//       const [statsRes, partiesRes] = await Promise.all([
//         axios.get(`${API_URL}/sundry/stats`, { headers: { Authorization: `Bearer ${token}` } }),
//         axios.get(`${API_URL}/sundry/parties`, { headers: { Authorization: `Bearer ${token}` } }),
//       ]);
//       setStats(statsRes.data);
//       setParties(Array.isArray(partiesRes.data) ? partiesRes.data : []);
//     } catch {
//       toast.error("Failed to load ledger data");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => { fetchAll(); }, [fetchAll]);

//   const filteredParties = useMemo(() =>
//     parties.filter((p) =>
//       p.party_type === activeTab &&
//       (!search || p.name.toLowerCase().includes(search.toLowerCase()) ||
//         p.phone?.includes(search) || p.gstin?.toLowerCase().includes(search.toLowerCase()))
//     ),
//     [parties, activeTab, search]
//   );

//   const totalBalance = useMemo(() =>
//     filteredParties.reduce((s, p) => s + Math.max(0, p.balance || 0), 0),
//     [filteredParties]
//   );

//   if (!canAccess)
//     return (
//       <div className="flex flex-col items-center justify-center min-h-[70vh] bg-[#f7f6f3]">
//         <AlertCircle size={48} className="text-stone-300 mb-4" />
//         <p className="font-black text-stone-600 text-lg">Access Denied</p>
//         <p className="text-stone-400 text-sm mt-1">You don't have permission to view this page.</p>
//       </div>
//     );

//   // ── Ledger view for selected party ─────────────────────────
//   if (selectedParty)
//     return (
//       <div className="min-h-full bg-[#f7f6f3] p-4 md:p-6 lg:p-8">
//         <LedgerView
//           party={selectedParty}
//           token={token}
//           onBack={() => { setSelectedParty(null); fetchAll(); }}
//           onPartyUpdated={fetchAll}
//         />
//       </div>
//     );

//   // ── Main list view ─────────────────────────────────────────
//   return (
//     <div className="min-h-full bg-[#f7f6f3] p-4 md:p-6 lg:p-8">
//       {/* ── Hero ── */}
//       <motion.div
//         initial={{ opacity: 0, y: -12 }}
//         animate={{ opacity: 1, y: 0 }}
//         className="relative overflow-hidden bg-[#1c1c2e] rounded-2xl p-6 mb-6 shadow-xl"
//       >
//         <div
//           className="absolute inset-0 opacity-10 pointer-events-none"
//           style={{
//             backgroundImage:
//               "radial-gradient(circle at 80% 30%, #f43f5e 0%, transparent 50%), radial-gradient(circle at 15% 70%, #3b82f6 0%, transparent 45%)",
//           }}
//         />
//         <div className="relative flex items-center justify-between gap-4">
//           <div className="flex items-center gap-4">
//             <div className="p-3 bg-amber-500/15 rounded-2xl border border-amber-500/20">
//               <Wallet size={24} className="text-amber-400" />
//             </div>
//             <div>
//               <h1 className="text-2xl md:text-3xl font-black text-white tracking-tight">Sundry Ledger</h1>
//               <p className="text-stone-400 text-sm mt-0.5">Debtors (receivable) & Creditors (payable)</p>
//             </div>
//           </div>
//           <button
//             onClick={fetchAll}
//             className="p-2.5 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors"
//           >
//             <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
//           </button>
//         </div>

//         {/* Stats */}
//         {stats && (
//           <div className="relative mt-5 pt-4 border-t border-white/10 grid grid-cols-2 sm:grid-cols-4 gap-4">
//             {[
//               { label: "Total Receivable", value: rupee(stats.total_debtors), color: "text-rose-400", sub: `${stats.debtor_count} debtors` },
//               { label: "Total Payable", value: rupee(stats.total_creditors), color: "text-blue-400", sub: `${stats.creditor_count} creditors` },
//               { label: "Net Position", value: rupee(Math.abs(stats.net_receivable)), color: stats.net_receivable >= 0 ? "text-emerald-400" : "text-amber-400", sub: stats.net_receivable >= 0 ? "Net receivable" : "Net payable" },
//               { label: "Overdue", value: stats.overdue_debtors + stats.overdue_creditors, color: "text-amber-400", sub: "parties >30 days" },
//             ].map((s, i) => (
//               <div key={i}>
//                 <p className="text-stone-500 text-[10px] uppercase tracking-wider font-semibold mb-0.5">{s.label}</p>
//                 <p className={`font-mono font-black text-2xl ${s.color}`}>{s.value}</p>
//                 <p className="text-[10px] text-stone-600 mt-0.5">{s.sub}</p>
//               </div>
//             ))}
//           </div>
//         )}
//       </motion.div>

//       {/* ── Tabs + Actions ── */}
//       <div className="flex flex-wrap items-center gap-3 mb-5">
//         {/* Tab toggle */}
//         <div className="flex bg-white rounded-xl border border-stone-200 p-1 gap-1 shadow-sm">
//           {[
//             { value: "debtor", label: "Debtors", color: "rose", count: parties.filter((p) => p.party_type === "debtor").length },
//             { value: "creditor", label: "Creditors", color: "blue", count: parties.filter((p) => p.party_type === "creditor").length },
//           ].map((tab) => (
//             <button
//               key={tab.value}
//               onClick={() => setActiveTab(tab.value)}
//               className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition-all ${
//                 activeTab === tab.value
//                   ? tab.value === "debtor"
//                     ? "bg-rose-500 text-white shadow-sm"
//                     : "bg-blue-500 text-white shadow-sm"
//                   : "text-stone-500 hover:text-stone-700"
//               }`}
//             >
//               {tab.label}
//               <span className={`text-[9px] font-black px-1.5 py-0.5 rounded-full ${activeTab === tab.value ? "bg-white/25" : "bg-stone-100"}`}>
//                 {tab.count}
//               </span>
//             </button>
//           ))}
//         </div>

//         {/* Search */}
//         <div className="relative flex-1 min-w-40">
//           <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
//           <input
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder={`Search ${activeTab === "debtor" ? "debtors" : "creditors"}…`}
//             className="w-full h-9 pl-8 pr-3 text-xs bg-white border border-stone-200 rounded-xl outline-none focus:ring-2 focus:ring-amber-500/30 text-stone-700"
//           />
//         </div>

//         {/* Total */}
//         <div className="bg-white border border-stone-200 rounded-xl px-3 py-2 text-xs text-stone-600 font-semibold shadow-sm">
//           Total: <span className={`font-mono font-black ${activeTab === "debtor" ? "text-rose-600" : "text-blue-600"}`}>{rupee(totalBalance)}</span>
//         </div>

//         {/* Add button */}
//         <button
//           onClick={() => setShowAddParty(true)}
//           className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-black transition-all ${
//             activeTab === "debtor"
//               ? "bg-rose-500 hover:bg-rose-400 text-white"
//               : "bg-blue-500 hover:bg-blue-400 text-white"
//           }`}
//         >
//           <Plus size={13} />
//           Add {activeTab === "debtor" ? "Debtor" : "Creditor"}
//         </button>
//       </div>

//       {/* ── Party List ── */}
//       {loading ? (
//         <div className="flex items-center justify-center h-40">
//           <Loader2 size={28} className="animate-spin text-amber-400" />
//         </div>
//       ) : filteredParties.length === 0 ? (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="flex flex-col items-center justify-center py-20 bg-white rounded-2xl border border-stone-100"
//         >
//           <div className={`p-4 rounded-2xl mb-3 ${activeTab === "debtor" ? "bg-rose-50" : "bg-blue-50"}`}>
//             <Users size={28} className={activeTab === "debtor" ? "text-rose-300" : "text-blue-300"} />
//           </div>
//           <p className="text-stone-500 font-semibold text-sm">
//             No {activeTab === "debtor" ? "debtors" : "creditors"} found
//           </p>
//           <p className="text-stone-400 text-xs mt-1">
//             {parties.filter((p) => p.party_type === activeTab).length === 0
//               ? `Click "Add ${activeTab === "debtor" ? "Debtor" : "Creditor"}" to get started`
//               : "Try a different search"}
//           </p>
//         </motion.div>
//       ) : (
//         <div className="space-y-2.5">
//           {filteredParties.map((party, i) => (
//             <PartyCard
//               key={party.id}
//               party={party}
//               index={i}
//               onClick={() => setSelectedParty(party)}
//             />
//           ))}
//         </div>
//       )}

//       {/* Modals */}
//       <AnimatePresence>
//         {showAddParty && (
//           <AddPartyModal
//             partyType={activeTab}
//             token={token}
//             onClose={() => setShowAddParty(false)}
//             onSaved={() => { setShowAddParty(false); fetchAll(); }}
//           />
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default SundryLedger;
import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";
import {
  Wallet,
  Search,
  ChevronRight,
  ArrowLeft,
  FileText,
  Banknote,
  AlertCircle,
  Phone,
  Trash2,
  ArrowUpRight,
  ArrowDownLeft,
  IndianRupee,
  RefreshCw,
  Loader2,
  Check,
  X,
  TrendingUp,
  TrendingDown,
  CreditCard,
  Receipt,
  Clock,
  CheckCircle2,
  AlertTriangle,
  Link,
} from "lucide-react";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ── Helpers ───────────────────────────────────────────────────
const rupee = (n) =>
  `₹${(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
const fmt = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "—";
const daysSince = (iso) => {
  if (!iso) return 0;
  return Math.floor(
    (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24),
  );
};

const ENTRY_META = {
  sale_invoice: {
    label: "Sale Invoice",
    icon: Receipt,
    color: "text-rose-500",
    bg: "bg-rose-500/12",
    border: "border-rose-500/20",
    isDebit: true,
  },
  payment_received: {
    label: "Payment Received",
    icon: Banknote,
    color: "text-emerald-500",
    bg: "bg-emerald-500/12",
    border: "border-emerald-500/20",
    isDebit: false,
  },
  purchase_invoice: {
    label: "Purchase Invoice",
    icon: CreditCard,
    color: "text-rose-500",
    bg: "bg-rose-500/12",
    border: "border-rose-500/20",
    isDebit: true,
  },
  payment_made: {
    label: "Payment Made",
    icon: Banknote,
    color: "text-emerald-500",
    bg: "bg-emerald-500/12",
    border: "border-emerald-500/20",
    isDebit: false,
  },
  debit_note: {
    label: "Debit Note",
    icon: TrendingUp,
    color: "text-orange-500",
    bg: "bg-orange-500/12",
    border: "border-orange-500/20",
    isDebit: true,
  },
  credit_note: {
    label: "Credit Note",
    icon: TrendingDown,
    color: "text-blue-500",
    bg: "bg-blue-500/12",
    border: "border-blue-500/20",
    isDebit: false,
  },
};

// ── Record Payment Modal ───────────────────────────────────────
const RecordPaymentModal = ({ party, token, onClose, onSaved }) => {
  const isDebtor = party.party_type === "debtor";
  const [form, setForm] = useState({
    amount: "",
    date: new Date().toISOString().split("T")[0],
    description: "",
    invoice_ref: "",
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const amt = parseFloat(form.amount);
    if (!amt || amt <= 0) {
      toast.error("Enter a valid amount");
      return;
    }
    setSaving(true);
    try {
      await axios.post(
        `${API_URL}/sundry/record-payment`,
        { ...form, party_id: party.id, amount: amt },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast.success(
        isDebtor ? "Payment received recorded!" : "Payment made recorded!",
      );
      onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to record payment");
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.94, y: 16 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.94, y: 16 }}
        transition={{ type: "spring", stiffness: 340, damping: 28 }}
        className="bg-[#1c1c2e] border border-white/10 rounded-3xl shadow-2xl w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-emerald-500/15 rounded-xl border border-emerald-500/20">
              <Banknote size={16} className="text-emerald-400" />
            </div>
            <div>
              <p className="text-[10px] text-stone-500 uppercase tracking-widest">
                Record Payment
              </p>
              <p className="text-white font-black text-sm">{party.name}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>

        {/* Context banner */}
        <div className="mx-6 mt-5 bg-emerald-500/10 border border-emerald-500/20 rounded-2xl px-4 py-3">
          <p className="text-[11px] text-emerald-400 font-bold">
            {isDebtor
              ? "💰 Recording money received from this customer"
              : "📤 Recording payment made to this supplier"}
          </p>
          <p className="text-[10px] text-stone-500 mt-0.5">
            This will reduce their outstanding balance
          </p>
        </div>

        {/* Form */}
        <div className="px-6 py-5 space-y-3">
          {/* Amount */}
          <div>
            <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">
              Amount Received (₹) *
            </label>
            <div className="relative">
              <IndianRupee
                size={13}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400"
              />
              <input
                type="number"
                min={0}
                autoFocus
                value={form.amount}
                onChange={(e) =>
                  setForm((f) => ({ ...f, amount: e.target.value }))
                }
                placeholder="0.00"
                className="w-full bg-white/8 border border-white/15 rounded-xl pl-8 pr-3 py-3 text-lg text-white font-mono font-bold outline-none focus:border-emerald-500/60 placeholder-stone-600 transition-colors"
              />
            </div>
          </div>

          {/* Date */}
          <div>
            <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">
              Date *
            </label>
            <input
              type="date"
              value={form.date}
              onChange={(e) => setForm((f) => ({ ...f, date: e.target.value }))}
              className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-emerald-500/60 transition-colors"
            />
          </div>

          {/* Reference */}
          <div>
            <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">
              Receipt / Cheque No.{" "}
              <span className="text-stone-600 font-normal normal-case">
                (optional)
              </span>
            </label>
            <input
              type="text"
              value={form.invoice_ref}
              onChange={(e) =>
                setForm((f) => ({ ...f, invoice_ref: e.target.value }))
              }
              placeholder="e.g. CHQ-00123"
              className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-emerald-500/60 placeholder-stone-600 transition-colors"
            />
          </div>

          {/* Notes */}
          <div>
            <label className="text-[10px] text-stone-400 font-bold uppercase tracking-wider block mb-1">
              Notes
            </label>
            <input
              type="text"
              value={form.description}
              onChange={(e) =>
                setForm((f) => ({ ...f, description: e.target.value }))
              }
              placeholder="Optional note..."
              className="w-full bg-white/8 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-emerald-500/60 placeholder-stone-600 transition-colors"
            />
          </div>
        </div>

        {/* Actions */}
        <div className="px-6 pb-5 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-2xl bg-stone-700/50 hover:bg-stone-700 text-stone-300 text-sm font-bold border border-white/10 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="flex-1 py-3 rounded-2xl bg-emerald-500 hover:bg-emerald-400 text-white text-sm font-bold flex items-center justify-center gap-2 transition-all disabled:opacity-50"
          >
            {saving ? (
              <Loader2 size={15} className="animate-spin" />
            ) : (
              <Check size={15} />
            )}
            {isDebtor ? "Mark Received" : "Mark Paid"}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

// ── Aging badge ───────────────────────────────────────────────
const AgingBadge = ({ lastTxDate }) => {
  const days = daysSince(lastTxDate);
  if (days < 7) return null;
  const { label, cls } =
    days >= 90
      ? {
          label: `${days}d — Critical`,
          cls: "bg-red-100 text-red-700 border-red-200",
        }
      : days >= 30
        ? {
            label: `${days}d — Overdue`,
            cls: "bg-amber-100 text-amber-700 border-amber-200",
          }
        : {
            label: `${days}d`,
            cls: "bg-stone-100 text-stone-500 border-stone-200",
          };
  return (
    <span
      className={`text-[9px] font-black px-1.5 py-0.5 rounded-full border ${cls}`}
    >
      {label}
    </span>
  );
};

// ── Party Card ─────────────────────────────────────────────────
const PartyCard = ({ party, index, onClick }) => {
  const isDebtor = party.party_type === "debtor";
  const bal = party.balance || 0;
  const isSettled = Math.abs(bal) < 0.01;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.025 }}
      onClick={onClick}
      className="group flex items-center justify-between p-4 bg-white rounded-2xl border border-stone-100 hover:border-stone-300 hover:shadow-md cursor-pointer transition-all active:scale-[0.99]"
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 rounded-xl flex items-center justify-center font-black text-sm shrink-0 ${
            isSettled
              ? "bg-emerald-100 text-emerald-600"
              : isDebtor
                ? "bg-rose-100 text-rose-600"
                : "bg-blue-100 text-blue-600"
          }`}
        >
          {party.name[0]?.toUpperCase()}
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-bold text-sm text-stone-800 truncate">
              {party.name}
            </p>
            {party.has_overdue && (
              <AgingBadge lastTxDate={party.last_transaction} />
            )}
            {isSettled && (
              <span className="text-[9px] font-black bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded-full border border-emerald-200">
                ✓ SETTLED
              </span>
            )}
          </div>
          <div className="flex items-center gap-2 mt-0.5">
            {party.phone && (
              <p className="text-[10px] text-stone-400 flex items-center gap-1">
                <Phone size={9} />
                {party.phone}
              </p>
            )}
            <p className="text-[10px] text-stone-400">
              {party.entry_count || 0} transactions
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <div className="text-right">
          <p
            className={`font-mono font-black text-base ${
              isSettled
                ? "text-emerald-600"
                : isDebtor
                  ? "text-rose-600"
                  : "text-blue-600"
            }`}
          >
            {rupee(Math.abs(bal))}
          </p>
          <p className="text-[9px] text-stone-400 font-semibold uppercase">
            {isSettled
              ? "Settled"
              : bal > 0
                ? isDebtor
                  ? "To Receive"
                  : "To Pay"
                : "Advance"}
          </p>
        </div>
        <ChevronRight
          size={14}
          className="text-stone-300 group-hover:text-stone-600 transition-colors"
        />
      </div>
    </motion.div>
  );
};

// ── Ledger Detail View ─────────────────────────────────────────
const LedgerView = ({ party, token, onBack, onPaymentRecorded }) => {
  const { user } = useAuth();
  const [ledger, setLedger] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const isDebtor = party.party_type === "debtor";
  const isAdmin = user?.role === "admin";

  const fetchLedger = useCallback(async () => {
    try {
      const res = await axios.get(
        `${API_URL}/sundry/parties/${party.id}/ledger`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setLedger(res.data);
    } catch {
      toast.error("Failed to load ledger");
    } finally {
      setLoading(false);
    }
  }, [party.id, token]);

  useEffect(() => {
    fetchLedger();
  }, [fetchLedger]);

  const handleDelete = async (entryId) => {
    setDeletingId(entryId);
    try {
      await axios.delete(`${API_URL}/sundry/entries/${entryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Entry deleted");
      fetchLedger();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to delete");
    } finally {
      setDeletingId(null);
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 size={28} className="animate-spin text-amber-400" />
      </div>
    );

  const {
    entries = [],
    closing_balance = 0,
    opening_balance = 0,
  } = ledger || {};
  const isSettled = Math.abs(closing_balance) < 0.01;
  const totalInvoiced = entries
    .filter((e) => ["sale_invoice", "purchase_invoice"].includes(e.entry_type))
    .reduce((s, e) => s + e.amount, 0);
  const totalPaid = entries
    .filter((e) => ["payment_received", "payment_made"].includes(e.entry_type))
    .reduce((s, e) => s + e.amount, 0);

  return (
    <div>
      {/* Party Header Card */}
      <div className="bg-[#1c1c2e] rounded-2xl p-5 mb-5 border border-white/8">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <button
              onClick={onBack}
              className="p-2 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors"
            >
              <ArrowLeft size={16} />
            </button>
            <div
              className={`w-11 h-11 rounded-xl flex items-center justify-center font-black text-lg shrink-0 ${
                isDebtor
                  ? "bg-rose-500/20 text-rose-300"
                  : "bg-blue-500/20 text-blue-300"
              }`}
            >
              {party.name[0]?.toUpperCase()}
            </div>
            <div>
              <p className="text-white font-black text-base">{party.name}</p>
              <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                <span
                  className={`text-[9px] font-black uppercase px-2 py-0.5 rounded-full border ${
                    isDebtor
                      ? "bg-rose-500/15 text-rose-400 border-rose-500/20"
                      : "bg-blue-500/15 text-blue-400 border-blue-500/20"
                  }`}
                >
                  {isDebtor ? "Debtor" : "Creditor"}
                </span>
                {party.phone && (
                  <span className="text-[10px] text-stone-500">
                    {party.phone}
                  </span>
                )}
                {party.gstin && (
                  <span className="text-[10px] text-stone-500 font-mono">
                    {party.gstin}
                  </span>
                )}
                {party.has_overdue && (
                  <span className="text-[9px] font-black bg-amber-500/20 text-amber-400 px-1.5 py-0.5 rounded-full border border-amber-500/25">
                    ⚠ OVERDUE
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Record Payment button — only if there's an outstanding balance */}
          {!isSettled && (
            <button
              onClick={() => setShowPaymentModal(true)}
              className="flex items-center gap-1.5 bg-emerald-500 hover:bg-emerald-400 text-white text-xs font-black px-4 py-2.5 rounded-xl transition-colors shadow-lg shadow-emerald-900/30"
            >
              <Banknote size={13} />
              {isDebtor ? "Record Payment" : "Mark as Paid"}
            </button>
          )}
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-4 gap-3 pt-4 border-t border-white/10">
          <div>
            <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">
              Total Invoiced
            </p>
            <p className="font-mono font-bold text-sm text-rose-400">
              {rupee(totalInvoiced + opening_balance)}
            </p>
          </div>
          <div>
            <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">
              Total {isDebtor ? "Received" : "Paid"}
            </p>
            <p className="font-mono font-bold text-sm text-emerald-400">
              {rupee(totalPaid)}
            </p>
          </div>
          <div>
            <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">
              Transactions {/* Credit due from POS sales */}
              {isDebtor &&
                (() => {
                  const creditEntries = entries.filter(
                    (e) => e.entry_type === "sale_invoice" && e.order_id,
                  );
                  const totalCreditSales = creditEntries.reduce(
                    (s, e) => s + e.amount,
                    0,
                  );
                  return totalCreditSales > 0 ? (
                    <div>
                      <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">
                        From POS Credit
                      </p>
                      <p className="font-mono font-bold text-sm text-amber-400">
                        {rupee(totalCreditSales)}
                      </p>
                    </div>
                  ) : null;
                })()}
            </p>
            <p className="font-mono font-bold text-sm text-stone-300">
              {entries.length}
            </p>
          </div>

          <div>
            <p className="text-[9px] text-stone-500 uppercase tracking-widest font-bold mb-0.5">
              {isSettled ? "Status" : isDebtor ? "Outstanding" : "To Pay"}
            </p>
            <p
              className={`font-mono font-black text-lg ${
                isSettled
                  ? "text-emerald-400"
                  : isDebtor
                    ? "text-rose-400"
                    : "text-blue-400"
              }`}
            >
              {isSettled ? "✓ Clear" : rupee(Math.abs(closing_balance))}
            </p>
          </div>
        </div>
      </div>

      {/* Ledger Table */}
      {entries.length === 0 ? (
        <div className="bg-white rounded-2xl border border-stone-100 flex flex-col items-center justify-center py-16">
          <FileText size={36} className="text-stone-200 mb-3" />
          <p className="text-stone-400 font-semibold text-sm">
            No transactions yet
          </p>
          <p className="text-stone-300 text-xs mt-1">
            Transactions will appear here when POS credit sales are made
          </p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden shadow-sm">
          {/* Header */}
          <div className="grid grid-cols-12 gap-2 px-5 py-3 bg-[#1c1c2e]">
            {[
              "Date",
              "Type / Reference",
              "Description",
              "Debit (Dr)",
              "Credit (Cr)",
              "Balance",
              "",
            ].map((h, i) => (
              <div
                key={i}
                className={`text-[9px] text-stone-400 font-bold uppercase tracking-widest ${
                  i === 0
                    ? "col-span-2"
                    : i === 1
                      ? "col-span-2"
                      : i === 2
                        ? "col-span-3"
                        : i === 3 || i === 4
                          ? "col-span-1 text-right"
                          : i === 5
                            ? "col-span-2 text-right"
                            : "col-span-1"
                }`}
              >
                {h}
              </div>
            ))}
          </div>

          <AnimatePresence>
            {entries.map((entry, idx) => {
              const meta =
                ENTRY_META[entry.entry_type] || ENTRY_META.sale_invoice;
              const isPosLinked = !!entry.order_id;
              return (
                <motion.div
                  key={entry.id}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: idx * 0.015 }}
                  className="grid grid-cols-12 gap-2 px-5 py-3 border-b border-stone-50 hover:bg-stone-50/60 transition-colors group items-center"
                >
                  {/* Date */}
                  <div className="col-span-2 text-xs text-stone-500 font-mono">
                    {fmt(entry.date)}
                  </div>

                  {/* Type */}
                  <div className="col-span-2">
                    <span
                      className={`inline-flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-full border ${meta.bg} ${meta.color} ${meta.border}`}
                    >
                      {meta.isDebit ? (
                        <ArrowUpRight size={8} />
                      ) : (
                        <ArrowDownLeft size={8} />
                      )}
                      {meta.label}
                    </span>
                    {(entry.invoice_number || entry.invoice_ref) && (
                      <p className="text-[9px] text-stone-400 mt-0.5 font-mono flex items-center gap-0.5">
                        {isPosLinked && (
                          <Link size={7} className="text-amber-500" />
                        )}
                        {entry.invoice_number || entry.invoice_ref}
                      </p>
                    )}
                  </div>

                  <div className="col-span-3">
                    <p
                      className="text-xs text-stone-500 truncate"
                      title={entry.description}
                    >
                      {entry.description || "—"}
                    </p>
                    {/* Show payment breakdown for POS credit sales */}
                    {entry.entry_type === "sale_invoice" && entry.order_id && (
                      <div className="flex flex-wrap gap-1.5 mt-0.5">
                        {/* We fetch the order's breakdown if available from the party ledger context */}
                        <span className="text-[9px] font-bold bg-amber-500/15 text-amber-400 border border-amber-500/20 px-1.5 py-0.5 rounded-full">
                          POS credit
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Debit */}
                  <div className="col-span-1 text-right">
                    {meta.isDebit ? (
                      <span className="font-mono font-semibold text-xs text-rose-600">
                        {rupee(entry.amount)}
                      </span>
                    ) : (
                      <span className="text-stone-300 text-xs">—</span>
                    )}
                  </div>

                  {/* Credit */}
                  <div className="col-span-1 text-right">
                    {!meta.isDebit ? (
                      <span className="font-mono font-semibold text-xs text-emerald-600">
                        {rupee(entry.amount)}
                      </span>
                    ) : (
                      <span className="text-stone-300 text-xs">—</span>
                    )}
                  </div>

                  {/* Running Balance */}
                  <div className="col-span-2 text-right">
                    <span
                      className={`font-mono text-xs font-bold ${
                        entry.running_balance > 0.01
                          ? isDebtor
                            ? "text-rose-600"
                            : "text-blue-600"
                          : "text-emerald-600"
                      }`}
                    >
                      {rupee(Math.abs(entry.running_balance))}
                    </span>
                    {Math.abs(entry.running_balance) < 0.01 && (
                      <p className="text-[8px] text-emerald-500 font-bold">
                        CLEAR
                      </p>
                    )}
                  </div>

                  {/* Delete (admin) */}
                  <div className="col-span-1 flex justify-end">
                    {isAdmin && (
                      <button
                        onClick={() => handleDelete(entry.id)}
                        disabled={deletingId === entry.id}
                        className="opacity-0 group-hover:opacity-100 p-1.5 hover:bg-rose-50 text-rose-400 rounded-lg transition-all"
                        title="Delete entry"
                      >
                        {deletingId === entry.id ? (
                          <Loader2 size={11} className="animate-spin" />
                        ) : (
                          <Trash2 size={11} />
                        )}
                      </button>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </AnimatePresence>

          {/* Closing balance footer */}
          <div className="grid grid-cols-12 gap-2 px-5 py-3 bg-stone-50 border-t-2 border-stone-200 items-center">
            <div className="col-span-8 text-xs font-black text-stone-700 uppercase tracking-wider">
              Closing Balance
            </div>
            <div className="col-span-1" />
            <div className="col-span-1" />
            <div className="col-span-2 text-right">
              <span
                className={`font-mono font-black text-base ${
                  isSettled
                    ? "text-emerald-600"
                    : isDebtor
                      ? "text-rose-600"
                      : "text-blue-600"
                }`}
              >
                {isSettled ? "₹0.00 ✓" : rupee(Math.abs(closing_balance))}
              </span>
            </div>
          </div>
        </div>
      )}

      <AnimatePresence>
        {showPaymentModal && (
          <RecordPaymentModal
            party={party}
            token={token}
            onClose={() => setShowPaymentModal(false)}
            onSaved={() => {
              setShowPaymentModal(false);
              fetchLedger();
              onPaymentRecorded?.();
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════
//  MAIN PAGE
// ═══════════════════════════════════════════════════════════════
const SundryLedger = () => {
  const { token, user } = useAuth();
  const [stats, setStats] = useState(null);
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("debtor");
  const [filter, setFilter] = useState("all"); // "all" | "outstanding" | "settled"
  const [search, setSearch] = useState("");
  const [showSettled, setShowSettled] = useState(false);
  const [selectedParty, setSelectedParty] = useState(null);

  const canAccess = ["admin", "manager", "billing"].includes(user?.role);

  const visibleParties = useMemo(
    () => (showSettled ? parties : parties.filter((p) => p.balance > 0.01)),
    [parties, showSettled],
  );

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [statsRes, partiesRes] = await Promise.all([
        axios.get(`${API_URL}/sundry/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_URL}/sundry/parties`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      setStats(statsRes.data);
      setParties(Array.isArray(partiesRes.data) ? partiesRes.data : []);
    } catch {
      toast.error("Failed to load ledger data");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const filteredParties = useMemo(
    () =>
      visibleParties.filter((p) => {
        if (p.party_type !== activeTab) return false;
        if (
          search &&
          !p.name.toLowerCase().includes(search.toLowerCase()) &&
          !p.phone?.includes(search)
        )
          return false;
        const bal = Math.abs(p.balance || 0);
        if (filter === "outstanding" && bal < 0.01) return false;
        if (filter === "settled" && bal >= 0.01) return false;
        return true;
      }),
    [visibleParties, activeTab, search, filter],
  );

  const outstandingTotal = useMemo(
    () =>
      visibleParties
        .filter((p) => p.party_type === activeTab && (p.balance || 0) > 0)
        .reduce((s, p) => s + (p.balance || 0), 0),
    [visibleParties, activeTab],
  );

  if (!canAccess)
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh] bg-[#f7f6f3]">
        <AlertCircle size={48} className="text-stone-300 mb-4" />
        <p className="font-black text-stone-600 text-lg">Access Denied</p>
      </div>
    );

  // Ledger detail view
  if (selectedParty)
    return (
      <div className="min-h-full bg-[#f7f6f3] p-4 md:p-6 lg:p-8">
        <LedgerView
          party={selectedParty}
          token={token}
          onBack={() => {
            setSelectedParty(null);
            fetchAll();
          }}
          onPaymentRecorded={fetchAll}
        />
      </div>
    );

  return (
    <div className="min-h-full bg-[#f7f6f3] p-4 md:p-6 lg:p-8">
      {/* ── Hero ── */}
      <motion.div
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative overflow-hidden bg-[#1c1c2e] rounded-2xl p-6 mb-6 shadow-xl"
      >
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 80% 30%, #f43f5e 0%, transparent 50%), radial-gradient(circle at 15% 70%, #3b82f6 0%, transparent 45%)",
          }}
        />
        <div className="relative flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-amber-500/15 rounded-2xl border border-amber-500/20">
              <Wallet size={24} className="text-amber-400" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-black text-white tracking-tight">
                Sundry Ledger
              </h1>
              <p className="text-stone-400 text-sm mt-0.5 flex items-center gap-2">
                Auto-synced from POS credit sales
              </p>
            </div>
          </div>
          <button
            onClick={fetchAll}
            disabled={loading}
            className="p-2.5 hover:bg-white/10 rounded-xl text-stone-400 hover:text-white transition-colors"
          >
            <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
          </button>
        </div>

        {stats && (
          <div className="relative mt-5 pt-4 border-t border-white/10 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[
              {
                label: "Total Receivable",
                value: rupee(stats.total_debtors),
                color: "text-rose-400",
                sub: `${stats.debtor_count} customers`,
              },
              {
                label: "Total Payable",
                value: rupee(stats.total_creditors),
                color: "text-blue-400",
                sub: `${stats.creditor_count} suppliers`,
              },
              {
                label: "Net Position",
                value: rupee(Math.abs(stats.net_receivable)),
                color:
                  stats.net_receivable >= 0
                    ? "text-emerald-400"
                    : "text-amber-400",
                sub:
                  stats.net_receivable >= 0 ? "Net receivable" : "Net payable",
              },
              {
                label: "Overdue (>30d)",
                value: stats.overdue_debtors + stats.overdue_creditors,
                color: "text-amber-400",
                sub: "parties overdue",
              },
            ].map((s, i) => (
              <div key={i}>
                <p className="text-stone-500 text-[10px] uppercase tracking-wider font-semibold mb-0.5">
                  {s.label}
                </p>
                <p className={`font-mono font-black text-2xl ${s.color}`}>
                  {s.value}
                </p>
                <p className="text-[10px] text-stone-600 mt-0.5">{s.sub}</p>
              </div>
            ))}
          </div>
        )}
      </motion.div>

      {/* ── How this works banner (shown only when no parties yet) ── */}
      {!loading && visibleParties.length === 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mb-5 bg-amber-50 border border-amber-200 rounded-2xl p-5"
        >
          <p className="font-black text-amber-800 text-sm mb-2">
            How credit sales work
          </p>
          <div className="space-y-1.5 text-xs text-amber-700">
            <p>
              1. In POS → select <strong>Credit</strong> payment mode
            </p>
            <p>
              2. Enter the <strong>amount received now</strong> (can be ₹0 or
              partial)
            </p>
            <p>
              3. The remaining balance <strong>auto-appears here</strong> under
              the customer's name
            </p>
            <p>
              4. When customer pays later →{" "}
              <strong>click the customer → Record Payment</strong>
            </p>
          </div>
        </motion.div>
      )}

      {/* ── Tabs + Filters ── */}
      <div className="flex flex-wrap items-center gap-3 mb-5">
        {/* Tab toggle */}
        <div className="flex bg-white rounded-xl border border-stone-200 p-1 gap-1 shadow-sm">
          {[
            {
              value: "debtor",
              label: "Debtors",
              count: visibleParties.filter((p) => p.party_type === "debtor")
                .length,
            },
            {
              value: "creditor",
              label: "Creditors",
              count: visibleParties.filter((p) => p.party_type === "creditor")
                .length,
            },
          ].map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition-all ${
                activeTab === tab.value
                  ? tab.value === "debtor"
                    ? "bg-rose-500 text-white shadow-sm"
                    : "bg-blue-500 text-white shadow-sm"
                  : "text-stone-500 hover:text-stone-700"
              }`}
            >
              {tab.label}
              <span
                className={`text-[9px] font-black px-1.5 py-0.5 rounded-full ${
                  activeTab === tab.value ? "bg-white/25" : "bg-stone-100"
                }`}
              >
                {tab.count}
              </span>
            </button>
          ))}
        </div>

        {/* Status filter */}
        <div className="flex bg-white rounded-xl border border-stone-200 p-1 gap-1 shadow-sm">
          {[
            { value: "all", label: "All" },
            { value: "outstanding", label: "Outstanding" },
            { value: "settled", label: "Settled" },
          ].map((f) => (
            <button
              key={f.value}
              onClick={() => setFilter(f.value)}
              className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                filter === f.value
                  ? "bg-stone-800 text-white shadow-sm"
                  : "text-stone-500 hover:text-stone-700"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="relative flex-1 min-w-40">
          <Search
            size={13}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400"
          />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by name or phone…"
            className="w-full h-9 pl-8 pr-3 text-xs bg-white border border-stone-200 rounded-xl outline-none focus:ring-2 focus:ring-amber-500/30 text-stone-700"
          />
        </div>

        {/* Outstanding total */}
        <div className="bg-white border border-stone-200 rounded-xl px-3 py-2 text-xs shadow-sm">
          <span className="text-stone-500">Outstanding: </span>
          <span
            className={`font-mono font-black ${
              activeTab === "debtor" ? "text-rose-600" : "text-blue-600"
            }`}
          >
            {rupee(outstandingTotal)}
          </span>
        </div>
      </div>

      {/* ── Party List ── */}
      {loading ? (
        <div className="flex items-center justify-center h-40">
          <Loader2 size={28} className="animate-spin text-amber-400" />
        </div>
      ) : filteredParties.length === 0 ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex flex-col items-center justify-center py-20 bg-white rounded-2xl border border-stone-100"
        >
          <div
            className={`p-4 rounded-2xl mb-3 ${
              activeTab === "debtor" ? "bg-rose-50" : "bg-blue-50"
            }`}
          >
            <Wallet
              size={28}
              className={
                activeTab === "debtor" ? "text-rose-300" : "text-blue-300"
              }
            />
          </div>
          <p className="text-stone-500 font-semibold text-sm">
            No{" "}
            {filter === "outstanding"
              ? "outstanding"
              : filter === "settled"
                ? "settled"
                : ""}{" "}
            {activeTab === "debtor" ? "debtors" : "creditors"} found
          </p>
          <p className="text-stone-400 text-xs mt-1">
            {visibleParties.filter((p) => p.party_type === activeTab).length ===
            0
              ? activeTab === "debtor"
                ? "Credit sales from POS will appear here automatically"
                : "Purchase entries will appear here automatically"
              : "Try a different filter"}
          </p>
        </motion.div>
      ) : (
        <div className="space-y-2.5">
          {filteredParties.map((party, i) => (
            <PartyCard
              key={party.id}
              party={party}
              index={i}
              onClick={() => setSelectedParty(party)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SundryLedger;
